// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		setTimeout(function () {
			$('#home').addClass('loaded');
		}, 4400);

		if ($.cookie('loader-wrapper') == null) {
			// Show welcome intro 
			$('#loader-wrapper').show();
			// Set the "welcome" cookie, so that the 
			// welcome intro will not be shown again during this visit
			$.cookie('loader-wrapper', true);
		} else {
			$('#loader-wrapper').hide();
		}

		//open and close menu with buttons
		const menuOpen = document.querySelector('.js-menu-open');
		const menuContainer = document.querySelector('.menu-container');
		const menuClose = document.querySelector('.js-menu-close');
		const header = document.querySelector('.header');

		function closeMenu() {
			menuContainer.classList.remove('expanded');
			setTimeout(function () {
				header.style.zIndex = "99";
				menuOpen.style.display = "block";
			}, 300);
		}

		menuOpen.addEventListener('click', () => {
			menuContainer.classList.add('expanded');
			menuOpen.style.display = "none";
		});
		menuClose.addEventListener('click', () => {
			closeMenu()
		});

		//header open menu
		const headerMenu = document.querySelector('.js-expand-menu');

		headerMenu.addEventListener('click', () => {
			if(menuContainer.classList.contains('expanded')) {
				closeMenu()
			} else {
				menuContainer.classList.add('expanded');
				menuOpen.style.display = "none";
				header.style.zIndex = "999";
			}
		});

		$('.hero_header').hide();
	

		setTimeout(function () {
			$('.hero_header').slideDown();
		}, 600);


		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});


		$('select').select2();
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		changeMenuColor();
		window.addEventListener('scroll', function(){
			scrollW();
			changeMenuColor();
		
		})
	};
	var scrollParallax = []
	var scrolled = 0

	// screen height
	var v_height = window.innerHeight
		|| document.documentElement.clientHeight
		|| document.body.clientHeight;

	function doParallax(elm) {

		let boundes = elm.dataset.parallax.split(",") // get it from html
		//get distance in positive value
		let distance = Math.abs(boundes[0] - boundes[1])
		if (boundes[0] > boundes[1]) {
			//get distance in negative value (to do the scroll inverse)
			distance = distance * -1
		}
		//Equivalent distance using screen height + element height
		const unit_scroll = distance / (v_height + elm.offsetHeight)
		let temp = 0
		let topElement = 0;
		let element = elm;
		let id_elem = elm.dataset.parallaxid

		do {
			topElement += element.offsetTop || 0;
			element = element.offsetParent;
		} while (element)

		let parallaxFunction = function () {
			//Obtain the distance between top screen and document top 0
			scrolled = document.documentElement.scrollTop || window.pageYOffset
			//Distance of bottom page to top of the element
			let relative_distance = scrolled + v_height - topElement
			//transpoling data to move the parallax element relative to the scroll of all the screen
			temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
			//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
			elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
		}

		scrollParallax[id_elem] = parallaxFunction

		window.addEventListener('scroll', scrollParallax[id_elem])

	}

	let observers_parallax = document.querySelectorAll(".js-parallax-element")

	if (observers_parallax) {
		let options_parallax = {
			root: null, // relative to document viewport
			rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
			threshold: 0 // visible amount of item shown in relation to root
		}

		function handler_parallax(entries, observer) {
			let entry;
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					doParallax(entry.target)
				} else {
					let id_elem = entry.target.dataset.parallaxid
					window.removeEventListener('scroll', scrollParallax[id_elem])
				}
			})
		}

		let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
		let counter = 1
		observers_parallax.forEach(function (element) {
			observable_parallax.observe(element)
			element.dataset.parallaxid = counter
			counter++
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}

		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function changeMenuColor() {
	var fixed = $(".js-menu-open");

    var fixed_position = $(".js-menu-open").offset().top;
    var fixed_height = $(".js-menu-open").height();

    var addClass = false;
    $('.dark-bg').each(function(){

        var toCross_position = $(this).offset().top;
        var toCross_height = $(this).height();

        if (fixed_position + fixed_height  < toCross_position) {
            
        } else if (fixed_position > toCross_position + toCross_height) {
           
        } else {
            addClass = true;
        }
    });
    if(addClass == true){
        fixed.addClass('change-color');
    }else{
        fixed.removeClass('change-color');
    }
}

